<template>
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="isLoaded" v-show="!isLoading">

    <!-- ════ INTRO MODAL — brief "machines in motion" beat on load, then it fades and the film plays ════ -->
    <div class="ty-intro" id="ty-intro" role="dialog" aria-modal="true" aria-label="The machines are in motion">
      <div class="ty-intro__panel">
        <div class="gl-stage ty-intro__gears" data-gears-loader aria-hidden="true">
          <div class="gl-bloom" data-gl="bloom"></div>
          <canvas class="gl-gl" data-gl="gl"></canvas>
          <canvas class="gl-fx" data-gl="fx"></canvas>
          <img width="250" data-gl="still"
            src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/gears-still.png"
            alt="">
          <video class="gl-video" data-gl="video"
            src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/videos/moving-gears.webm"
            preload="auto" playsinline muted loop></video>
        </div>
        <h1>The Machines<br>Are In Motion</h1>
        <p>Your receipt is making its way through the factory now. Stand by while we prepare what comes next.</p>
      </div>
    </div>

    <!-- ════ THANK YOU STAGE — video plays once, holds, blurs, then the card reveals ════ -->
    <section class="ty-stage" id="ty-stage" data-screen-label="Thank You">
      <video class="ty-media ty-video" id="ty-video" muted playsinline preload="auto"
        poster="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/ty-firstframe-desktop.jpg">
        <source
          src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/videos/thankyou-mobile.mp4"
          type="video/mp4" media="(max-width:768px)">
        <source
          src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/videos/thankyou-desktop.mp4"
          type="video/mp4">
      </video>
      <picture class="ty-media ty-firstframe" id="ty-firstframe" aria-hidden="true">
        <source media="(max-width:768px)"
          srcset="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/ty-firstframe-mobile.jpg">
        <img
          src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/ty-firstframe-desktop.jpg"
          alt="" decoding="async">
      </picture>
      <picture class="ty-media ty-blur" id="ty-blur" aria-hidden="true">
        <source media="(max-width:768px)"
          srcset="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/ty-blur-mobile.jpg">
        <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/ty-blur-desktop.jpg"
          alt="" decoding="async">
      </picture>
      <div class="ty-accents" aria-hidden="true"></div>
      <div class="ty-card" id="ty-card">
        <span class="card-glow" aria-hidden="true"></span>
        <img class="ty-ticket"
          src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/ticket-search-begun.png"
          alt="Your Search Has Begun" decoding="async">
        <p class="eyebrow">Splendiferous!</p>
        <h2>We'll Handle The Magic From Here</h2>
        <p class="ty-card__copy">The Oompa Loompas are reviewing your submission now. Keep an eye on your inbox,
          we'll let you know once your qualifying purchase has been approved.</p>
        <div class="ty-actions">
          <router-link to="/Upload" class="btn-gold">Upload Another Receipt</router-link>
          <router-link to="/" class="btn-outline-light">Return To The Factory</router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import PageLoader from '@/components/UI/PageLoader.vue';

export default {
  name: 'ThanksPage',
  components: { PageLoader },
  data() {
    return {
      isLoading: true,
      isLoaded: false,
    };
  },
  mounted() {
    // ✅ Dynamically import gears-loader.js after the component mounts so the
    // DOM elements it targets (#gears-loader, [data-gl]) are already in the page
    import('../../../public/assets/js/gears-loader.js');

    this.isLoaded = true;
    // ✅ Wait for the loader to clear, then let Vue flush the DOM before starting the sequence
    setTimeout(() => {
      this.isLoading = false;
      this.$nextTick(() => this.initThankyouSequence());
    }, 1500);

   
  },
  methods: {
    
    // ✅ Thank-you sequence: intro modal holds a beat, fades out, then the film plays once,
    // holds on its last frame, the background blurs, and the message card slides up.
    initThankyouSequence() {
      var stage = document.querySelector('.ty-stage');
      if (!stage) return;

      var video = stage.querySelector('.ty-video');
      var blur = stage.querySelector('.ty-blur');
      var card = stage.querySelector('.ty-card');
      var firstframe = document.getElementById('ty-firstframe');
      var intro = document.getElementById('ty-intro');
      var staticMode = /[?&]static=1/.test(window.location.search);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function reveal() {
        blur.classList.add('is-in');
        setTimeout(function () { card.classList.add('is-in'); }, 520);
      }

      function endNow() {
        if (video) { try { video.pause(); } catch (e) { /* pause() may throw if video is not yet loaded — safe to ignore */ } }
        blur.classList.add('is-in');
        card.classList.add('is-in');
      }

      function startVideo() {
        if (reduce || !video) { endNow(); return; }
        video.addEventListener('ended', function () { setTimeout(reveal, 750); });
        video.addEventListener('error', endNow);
        var p = video.play();
        if (p && p.catch) p.catch(function () { endNow(); });
      }

      var done = false, timer = null;

      function dismissIntro() {
        if (done) return; done = true;
        if (timer) clearTimeout(timer);
        document.body.style.overflow = '';
        if (firstframe) firstframe.classList.add('is-gone');
        if (staticMode) { endNow(); }    // static fallback: no video, straight to end card
        else { startVideo(); } // get the film running underneath
        setTimeout(function () {          // then fade the opaque modal to reveal it
          if (intro) { intro.classList.remove('is-in'); intro.setAttribute('aria-hidden', 'true'); }
        }, 260);
      }

      // Always show the intro transition first. Under reduced motion it appears without
      // fade and the gears render as a still frame (see gears-loader.js), then it dismisses
      // straight to the end card (startVideo() falls back to endNow() when reduce is set).
      if (intro) {
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { intro.classList.add('is-in'); });
        });
        intro.addEventListener('click', dismissIntro);  // tap to skip
        timer = setTimeout(dismissIntro, 4600);         // hold a beat then auto-dismiss
      } else {
        if (staticMode) { endNow(); } else { startVideo(); }
      }
    },
  },
};
</script>

<style scoped>
.ty-stage {
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>